export default __webpack_public_path__ + "static/media/creme-brulee.08624273.jpg";